import * as types from '../mutation-type'
import * as localStorage from '../localStorage'

const state = localStorage.showPage.get() || {
  msg_reads: [] // 设置header菜单点击显示
}

const getters = {
  msg_reads: state => state.msg_reads
}

const mutations = {
  [types.SET_READ] (state, info) {
    try {
      state.msg_reads = info
      state.time = localStorage.getDate()
      localStorage.showPage.set(state)
    } catch (err) {
    }
  }
}

const actions = {
  set_read ({commit}, param) {
    commit(types.SET_READ, param)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/setRead.js